import has from 'lodash/has'
import { NestedModel } from "../nestedmodel";
import {debug_log} from "../../logger";


export class SubId extends NestedModel {
    constructor(props, attributes) {
        super(props, Object.assign({}, attributes));
        this.variables = new NestedModel({value: 'variables', parent: this});
        this.alarms = new NestedModel({value: 'alarms', parent: this});
        this.alarmHistory = new NestedModel({value: 'alarmHistory', parent: this});
    }

    save(attributes, options) {
        // FIXME: Must return a Promise
        if(!has(this.changes, 'data')){
            return;
        }
        const data = this.changes.data;
        debug_log('PUT data:', data);
        return this.rpcPut('', data).then(
            () => {
                this.commitChanges()
            });
    }
}